/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable no-use-before-define */
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Stack,
  Avatar,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import Modal from '@mui/base/Modal';
import MarkChatReadOutlinedIcon from '@mui/icons-material/MarkChatReadOutlined';
import { tokens } from '../../src/tokens';
import TestChat from './testchat';
import LightTooltip from '../../src/utils/LightTooltip';

const IconText = styled(Typography)(() => ({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontSize: '0.575rem',
  fontWeight: 500,
  color: tokens.palette_primary,
  // '&:hover': {
  //   color: tokens.palette_secondary,
  // },
}));

const StyledIcon = styled(IconButton)(() => ({
  paddingTop: '2px',
  paddingBottom: '2px',
  height: '18px',
  width: '18px',
  color: tokens.palette_primary,
  '&:hover': {
    color: tokens.palette_secondary,
  },
}));


export default function ModalDemo() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>

        <TriggerButton
          type="button"
          onClick={handleOpen}
        >
          <Stack alignItems="center">
            <StyledIcon>
              <MarkChatReadOutlinedIcon
                fontSize="small"
                sx={{ color: tokens.palette_secondary }}
              />
            </StyledIcon>
            <IconText variant="caption">ChatBot</IconText>
          </Stack>
        </TriggerButton>

      <StyledModal
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={open}
        onClose={handleClose}
        slots={{ backdrop: StyledBackdrop }}
      >
        {/* <Box sx={style}> */}
        <Box sx={{}}>
          <TestChat />
        </Box>
      </StyledModal>
    </div>
  );
}

const Backdrop = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={clsx({ 'MuiBackdrop-open': open }, className)}
      ref={ref}
      {...other}
    />
  );
});

Backdrop.propTypes = {
  className: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

const blue = {
  200: '#99CCF3',
  400: '#3399FF',
  500: '#007FFF',
};

const grey = {
  50: '#f6f8fa',
  100: '#eaeef2',
  200: '#d0d7de',
  300: '#afb8c1',
  400: '#8c959f',
  500: '#6e7781',
  600: '#57606a',
  700: '#424a53',
  800: '#32383f',
  900: '#24292f',
};

const StyledModal = styled(Modal)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  -webkit-tap-highlight-color: transparent;
`;

const style = (theme) => ({
  width: 700,
  borderRadius: '12px',
  padding: '16px 32px 24px 32px',
  backgroundColor: theme.palette.mode === 'dark' ? '#0A1929' : 'white',
  boxShadow: `0px 2px 24px ${
    theme.palette.mode === 'dark' ? '#000' : '#383838'
  }`,
});

const TriggerButton = styled('button')(
  ({ theme }) => `
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  box-sizing: border-box;
  min-height: calc(1.5em + 22px);
  border-radius: 12px;
  padding: 6px 12px;
  line-height: 1.5;
  background: transparent;
  border: 1px solid transparent;
  color: ${tokens.token_grey_100};
  &:hover {
    background: ${tokens.token_grey_10};
    border-color: ${tokens.token_grey_300};
  }
  &:focus-visible {
    border-color: ${tokens.token_blue_500};
    outline: 3px solid ${tokens.token_blue_200};
  }
  `
);
